import { useEffect } from "react";

export function usePostMessage(windowToPost: Window, domain: string, dataToSendOnChange: any): void {
  useEffect(() => {
    if (dataToSendOnChange && domain) {
      windowToPost.postMessage(dataToSendOnChange, domain);
    }
  }, [dataToSendOnChange, domain, windowToPost]);
}
